import type { BlockchainAction } from "@opensea/graphql"
import type { ExpirationOptions } from "../../lib/zod/expiration"

export const MINIMUM_OFFER_PRICE = 0.0001
export const MINIMUM_LISTING_PRICE = 0.000_000_000_000_01

export const OFFER_MAX_DECIMALS = 4
export const LISTING_MAX_DECIMALS = 14

// Types of actions that must be awaited before moving on to next action
export const AWAITED_TRANSACTION_TYPES: BlockchainAction["__typename"][] = [
  "ItemApprovalAction",
  "PaymentApprovalAction",
  "WrapAction",
  "UnwrapAction",
  "SetTransferValidatorAction",
]

export const RECEIPT_TRANSACTION_TYPES: BlockchainAction["__typename"][] = [
  "BuyItemAction",
  "SvmBuyItemsAction",
  "AcceptOfferAction",
  "CancelOrdersAction",
  "CancelAllOrdersAction",
  "TransferAssetsAction",
  "SwapAssetsAction",
  "SvmSwapAssetsAction",
]

export const DEFAULT_EXPIRATION: ExpirationOptions = "30 days"

export const CREATOR_FEE_ENFORCED_LOCAL_STORAGE = "creatorFeeEnforced"

export const LISTING_EXPIRATION_LOCAL_STORAGE = "listingExpiration"
export const LISTING_EXPIRATION_CUSTOM_EXPIRATION_LOCAL_STORAGE =
  "listingExpirationCustom"

export const OFFER_EXPIRATION_LOCAL_STORAGE = "offerExpiration"
export const OFFER_EXPIRATION_CUSTOM_EXPIRATION_LOCAL_STORAGE =
  "offerExpirationCustom"

export const ORDER_PRICE_LOW_SEVERITY_WARNING_THRESHOLD_PERCENTAGE = 0.05 // 5%
export const ORDER_PRICE_HIGH_SEVERITY_WARNING_THRESHOLD_PERCENTAGE = 0.2 // 20%
export const ITEM_OFFER_HIGH_SEVERITY_WARNING_THRESHOLD = 5 // 5x price

export const TRAIT_OFFER_LOW_SEVERITY_WARNING_THRESHOLD_PERCENTAGE = 0.75 // 75% for trait offers
export const TRAIT_OFFER_HIGH_SEVERITY_WARNING_THRESHOLD_PERCENTAGE = 1 // 100% for trait offers

export const MAX_NUM_TRAITS_FOR_MULTI_TRAIT_OFFERS = 2
